<template>
    <div class="slide">

        <go-back />

        <div class="next" @click="next" v-if="nextStepEnabled">
            <img src="/assets/img/icon-arrow-right-blue.svg" />
        </div>

        <div class="slide-container">

            <div class="question bigger">
                How <span>old</span> are you?
            </div>

            <div class="answer answer-col">

                <div class="row">
                    <div class="col-md-12">

                        <div class="row">
                            <div class="col-md-4">
                                <v-text-field
                                label="Your age" v-model="personOneAge" class="inputNumber"
                                ></v-text-field>
                            </div>
                        </div>

                        <div class="row" v-if="personTwoExists">
                            <div class="col-md-4">
                                <v-text-field
                                :label="personTwo.name+`'s age`" v-model="personTwoAge" class="inputNumber"
                                ></v-text-field>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
import GoBack from "./GoBack";
export default {
    name: 'IndividualAge',
    components: {
        GoBack
    },
    methods: {
        next() {
            // Save individuals
            this.$store.dispatch('individuals/saveIndividuals');

            this.$router.push({ name: 'SectionTwo' });
        },
        nextStepEnabled() {
            return this.personOneAge !== 0 && this.personTwoAge !== 0 || !this.personTwoExists && this.personOneAge !== 0
        }
    },
    computed: {
        ...mapGetters('individuals', [
            'personOne',
            'personTwo',
            'personTwoExists',
        ]),
        personOneAge: {
            get () {
                return this.personOne.current_age
            },
            set (value) {
                this.$store.commit('individuals/setPersonOneAge', value);
            }
        },
        personTwoAge: {
            get () {
                if (this.personTwoExists) {
                    return this.personTwo.current_age
                }
                return 0;
            },
            set (value) {
                this.$store.commit('individuals/setPersonTwoAge', value);
            }
        },
    }
}
</script>
